export const defaultFormDataAppartement = {
  additionalComments: '',
  adresse: '',
  apartmentStyle: '',
  apartmentType: '',
  apartmentUsage: '',
  ascenseurDisponibilite: '',
  budgetRange: [30000, 250000],
  ceilingHeight: 0,
  chambresSalonEquipe: false,
  cuisineEquipe: false,
  dateNaissance: '',
  desiredFloorLevel: [0, 25],
  distanceToUrbanCenter: 0,
  email: '',
  familyComposition: '',
  garageType: '',
  healthServices: false,
  neighborhoodType: '',
  nom: '',
  otherViewPreferences: '',
  prenom: '',
  publicMerProximity: '',
  purchaseDate: '',
  recreation: false,
  restrictions: '',
  schools: false,
  shops: false,
  surfaceRange: [100, 110],
  telephone: '',
  transports: false,
  viewCity: false,
  viewCompagne: false,
  viewMountains: false,
  viewSea: false,
};
